<span (click)="onRemoveDebugTag()" *ngIf="shouldShowDebugTag"> v{{ version }} </span>
